import React from 'react';
import { Popup, List } from '@leverege/ui-elements';
import { jsx as _jsx } from "react/jsx-runtime";
export default function Suggestion(props) {
  const {
    contents,
    newSearch,
    search,
    onSearchChange,
    variant,
    renderAs,
    onClose
  } = props;
  if (!contents || newSearch === search) {
    return null;
  }
  if (renderAs === 'list') {
    return /*#__PURE__*/_jsx(List.Item, {
      variant: variant,
      children: /*#__PURE__*/_jsx("div", {
        style: {
          whiteSpace: 'pre-wrap'
        },
        onClick: () => {
          onClose?.();
          onSearchChange({
            value: newSearch
          });
        },
        children: contents
      })
    });
  }
  return /*#__PURE__*/_jsx(Popup.Item, {
    variant: variant,
    style: {
      whiteSpace: 'pre-wrap'
    },
    onClick: () => {
      onClose?.();
      onSearchChange({
        value: newSearch
      });
    },
    children: contents
  });
}